import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import {
  deleteGroup, postNewGroup, syncGroupsList, toggleAddPopup,
} from '@app/actions/groups/groups'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import GroupsList from '@app/components/Groups/GroupsList/GroupsList'
import {
  withAccessDenied, withNotifications, withProgressAndErrorMessage, withRefresh,
} from '@app/hocs'
import { checkIfAdmin } from '@app/helpers/checkIfAdmin'

let enhance = GroupsList

const mapStateToProps = (state) => {
  const { isMobile, isTablet } = state.mobileDetector
  const {
    groups: {
      isAddPopupOpen,
      groupsList,
    },
  } = store.getState()
  return {
    isMobile,
    isTablet,
    groupsList,
    isAddPopupOpen,
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
    inProgress: state.apiRequest.inProgress,
    errorMessage: state.apiRequest.errorMessage,
    accessToken: state.secrets.accessToken && state.secrets.accessToken.token,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    admin: checkIfAdmin(state.users.currentUser.user.role),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  refresh: syncGroupsList,
  tryAgain: syncGroupsList,
  notifications: syncNotifications.sync,
  syncGroupsList,
  postNewGroup,
  toggleAddPopup,
  deleteGroup,
}, dispatch)

enhance = withRefresh(enhance)
enhance = withNotifications(enhance)
enhance = withProgressAndErrorMessage(enhance)
enhance = withAccessDenied(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const GroupsEnhanced = enhance

export default GroupsEnhanced
